module.exports = __webpack_public_path__ + "static/media/wedding9.404eef5b.jpg";